import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';
import { noWhitespaceValidator } from '../../../../shared/src/lib/service/helper.service';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'piqet-angular-add-state',
  templateUrl: './add-state.component.html',
  styleUrls: ['./add-state.component.scss'],
  providers: [TitleCasePipe],
})
export class AddStateComponent {
  modalLabel: any;
  adminStateData: any;
  stateAddEditForm!: FormGroup;
  submitted = false;
  activatedRoute: any;
  countryList: any;
  regionData: any;
  regionItems: any;
  selectCountry: any;
  isDisabledDropDown!: boolean;
  @Output() saveStateEvent = new EventEmitter<any>();

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private titleCasePipe: TitleCasePipe
  ) {
    this.adminStateData = this.modal?.modalService?.config?.initialState?.['stateData'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.countryList = this.adminStateData.countryItems;
    this.getRegionData();
  }

  ngOnInit(): void {
    this.stateAddEditForm = this.formBuilder.group({
      country: [null, Validators.required],
      state: [this.adminStateData.name || '', [Validators.required, noWhitespaceValidator]],
    });
    this.setFormData();
  }

  async getRegionData() {
    await this.countryList.map((item: any) => {
      if (item.id == this.adminStateData.countryId) {
        return (this.selectCountry = item);
      }
    });
  }

  setFormData() {
    this.stateAddEditForm.patchValue({ country: this.selectCountry });
  }

  onSave() {
    this.submitted = true;
    if (!this.stateAddEditForm.controls['state'].value) {
      return;
    }
    if (this.stateAddEditForm.status == 'VALID') {
      const countryPayload = {
        id: this.adminStateData.id || 0,
        name: this.stateAddEditForm.controls['state'].value.trimStart(),
        countryId:
          this.stateAddEditForm.controls['country'].value.id ||
          this.stateAddEditForm.controls['country'].value,
      };
      this.saveStateEvent.emit(countryPayload);
      this.onClose();
    }
  }

  onClose() {
    this.modal.close();
  }

  commonInputSearch(term: string, item: any) {
    return item.name?.toLowerCase().includes(term.toLowerCase());
  }
}
